import { useSearchParams } from "react-router-dom";

export function usePaginationParams(pageSize: number, total: number) {
  const [searchParams, setSearchParams] = useSearchParams();
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const page = Math.min(totalPages, Math.max(1, parseInt(searchParams.get("page") ?? "1", 10)));

  const setPage = (next: number) => {
    setSearchParams((prev) => {
      prev.set("page", String(next));
      return prev;
    });
  };

  return { page, totalPages, setPage };
}
